<template>
    <div>
        <!--采购报表-->
        <Card :bordered="false" dis-hover>
            <p slot="title">库存详情</p>
             <div>分类: {{pageData.type_goods}} - {{pageData.type_item}}</div>
             <div class="orderdel">
                 <div>
                     <Fy-Img
                             class="img"
                             :ImgSrc="pageData.goodsimg | filtImg(pageData.goodsimg)"
                             :Width="100"
                             :Height="100"
                     ></Fy-Img>
                 </div>
                 <div>
                     <p>商品名称：{{pageData.name}}</p>
                     <p>商品货号：{{pageData.goodscode}}</p>
                     <p>
                         <span>总库存：{{allnums}}<strong class="result"></strong></span>
                         <span>库存预警下限：<strong class="result">{{pageData.warning}}</strong></span>
                     </p>
                     <p>
                         <span>批发价：<strong class="result">{{pageData.pprice}}</strong></span>
                         <span>零售价：<strong class="result">{{pageData.lprice}}</strong></span>
                         <span v-if="allmoneyflag">成本金额：<strong class="result">{{allmoney}}</strong></span>
                     </p>
                 </div>
             </div>
            <div class="delgroup">
                <strong>颜色</strong>
            </div>
            <div class="colorgroup">
                 <span v-for="(item,index) in pageData.colors" :class="{selectename:selected==index}" @click="changeTab(item,index)">{{item.color}}</span>
            </div>
            <div class="sizecode">
                    <Row>
                        <Col span="3">
                            <strong>尺码</strong>
                            <p  v-for="(item,index) in sizeGroup" v-if="item.size">{{item.size}}</p>
                            <strong>合计：</strong>
                        </Col>
                        <Col span="3">
                            <strong>当前库存量</strong>
                            <p  v-for="(item,index) in sizeGroup" v-if="item.num">{{item.num}}</p>
                            <strong>{{allnumber}}</strong>
                        </Col>
                    </Row>
            </div>

        </Card>

    </div>
</template>
<script>

    export default {
        data() {
            return {
                cid:'',
                sid:'',
                allnums:0,//总库存
                pageData:{},
                selected:0,
                sizeGroup:[],
                allnumber:0,//合计
                allmoney:0,//成本金额
                allmoneyflag:false,//是否有权限查看
                inferior:false,//是否查询残次品
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            let selectId  = this.$route.query.id
            let inferior = this.$route.query.inferior
            this.inferior = inferior
            let data = {
                id:selectId,
                inferiorFlag:'0'
            }
            if(new String(inferior)=='true'){
                data.inferiorFlag = '1'
                let shopData =  this.$store.state.shopData
                data.cid=this.cid
                data.sid =this. sid
                data.page = 1
                console.log(shopData)
                this.getGoodsList(data)
            }else{
                this.selectStock(selectId)
            }

        },

        methods: {
            //获取数据
            selectStock(id){
                this.$Api.selectStock({
                    goodsid:id
                }).then(res => {
                    if(res.code==200){
                        this.sizeGroup=[]
                        this.pageData = res.data
                        this.allmoney=0
                        this.pageData.stockItem.forEach((item)=>{
                            this.allnums+=item.num
                            this.allmoney += item.num*item.cprice
                             if(this.pageData.colors[0].color==item.color){
                                 if(!item.size){
                                     item.size= '* '
                                 }
                                 if(item.num==0){
                                     item.num='0'
                                 }
                                 this.allnumber+= parseInt(item.num)
                                 this.sizeGroup.push(item)
                             }
                        })
                        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
                        if(PermisCode.includes('94')){
                           this.allmoneyflag=true
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //获取数据
            getGoodsList(data){
                this.$Api.getGoodsList(data).then(res => {
                    if(res.code==200){
                        this.sizeGroup=[]
                        this.pageData = res.data[0]
                        this.allmoney=0
                        this.pageData.goodsItem.forEach((item)=>{
                            this.allnums+=item.num
                            this.allmoney += item.num*item.cprice
                             if(this.pageData.colors[0].color==item.color){
                                 if(!item.size){
                                     item.size= '* '
                                 }
                                 if(item.num==0){
                                     item.num='0'
                                 }
                                 this.allnumber+= parseInt(item.num)
                                 this.sizeGroup.push(item)
                             }
                        })
                        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
                        if(PermisCode.includes('94')){
                           this.allmoneyflag=true
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            changeTab(data,i){
                this.selected=i
                this.sizeGroup=[]
                var isarr=[]
                this.allnumber=0    
                if(this.inferior=='false'){
                    this.pageData.stockItem.forEach((item)=>{
                    if(data.color==item.color){
                        console.log(item.num)
                        if(!item.size){
                            item.size= '* '
                        }
                        this.allnumber+=item.num
                        if(item.num==0){
                            item.num='0'
                        }

                        isarr.push(item)
                    }

                    })
                }else{
                    this.pageData.goodsItem.forEach((item)=>{
                    if(data.color==item.color){
                        console.log(item.num)
                        if(!item.size){
                            item.size= '* '
                        }
                        this.allnumber+=item.num
                        if(item.num==0){
                            item.num='0'
                        }

                        isarr.push(item)
                    }

                    })
                }
                
                this.sizeGroup=isarr

            },
        }
    };
</script>

<style lang="scss" scoped>
.orderdel{
    overflow: auto;
    margin-top: 10px;
    div{
        float: left;
        margin-right: 10px;
        line-height: 25px;
        p{
            span{
                padding-right: 30px;
            }
        }
    }
}
.result{
    color: #ff9800;
}
    .delgroup{
        margin-top: 40px;
        margin-bottom: 10px;
        border-bottom: 1px solid #e8eaec;
    }
table tr td{
    padding: 15px;
}
    .sizecode{
        padding-top: 20px;
        p{
            line-height: 26px;
        }
    }
    .colorgroup{
        span{
            display: inline-block;
            padding: 3px 7px;
            border: 1px solid #cccccc;
            border-radius: 5px;
            font-size: 14px;
            cursor: pointer;
            margin-right:10px;
        }
    }
    .selectename{
        background: #ff9800;
        color: #ffffff;
        border: 1px solid #ff9800 !important;
    }
</style>